// `matchMedia` aboneliği — Geçmiş Rapor Aktarımı (Task 13, tasarım review 1A + 5A).
// Yeni bağımlılık eklemeden iki ihtiyacı karşılar:
//   · ≤ 1100 px satır tablosu → kart düzeni (1A)
//   · `prefers-reduced-motion: reduce` → ilerleme animasyonu kapanır (5A)
// SSR/test ortamında (`window` yok) her zaman `false` döner.

import { useEffect, useState } from "react";

export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(
    () => typeof window !== "undefined" && window.matchMedia(query).matches,
  );
  useEffect(() => {
    if (typeof window === "undefined") return;
    const mql = window.matchMedia(query);
    const onChange = (): void => setMatches(mql.matches);
    onChange();
    mql.addEventListener("change", onChange);
    return () => mql.removeEventListener("change", onChange);
  }, [query]);
  return matches;
}

/** 5A — animasyon yalnız kullanıcı hareketli arayüz istediğinde çalışır. */
export function usePrefersReducedMotion(): boolean {
  return useMediaQuery("(prefers-reduced-motion: reduce)");
}
